/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Κωδικός',
    COUNTERPARTS: 'Αντίπαλοι',
    CURRENT: 'Τρέχον',
    GENERAL_INFORMATION: 'Γενικές πληροφορίες',
    MANAGER: 'Διευθυντής',
    PREVIOUS: 'Προηγούμενο',
    PRODUCTS: 'Προϊόντα',
    REMUNERATION: 'Αποδοχές',
    SUPERVISOR: 'Επόπτης'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
